import React__default, { useCallback } from 'react';
import { Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import { SpecialOffers } from '../../../SpecialOffers/src/SpecialOffers.js';

const SpecialOffersContent = (props) => {
    const { pushEvent, section, tabs, abName, iframeSrc, setContentLoaded, setActiveTab } = props;
    const isMobile = useIsMobile();
    const handleSetItemsCount = useCallback((count) => {
        if (!count) {
            setContentLoaded(false);
            return;
        }
        if (count > 0) {
            setContentLoaded(true);
        }
    }, [setContentLoaded]);
    const pushEventWithSection = useCallback((event) => {
        pushEvent({
            ...event,
            eventAction: `${event.eventAction}|Попап ${section}`,
        });
    }, [pushEvent, section]);
    return (React__default.createElement(SpecialOffers, { isWithButtons: true, pushEvent: pushEventWithSection, tabs: tabs, abName: abName, iframeSrc: iframeSrc, insidePopup: true, heading: React__default.createElement(Typography.Heading, { level: 3 }), headingType: isMobile ? 'horizontal' : 'popover', setItemsCount: handleSetItemsCount, onTabChange: setActiveTab }));
};

export { SpecialOffersContent };
//# sourceMappingURL=SpecialOffersContent.js.map
